import { isAppleVisionPro, isWebView } from "./webViewUtils";

interface NavigatorWithUAData extends Navigator {
  userAgentData?: {
    brands?: Array<{
      brand: string;
      version: string;
    }>;
  };
}

const getNormalizedBrands = (): string[] => {
  if (typeof navigator === "undefined") {
    return [];
  }

  const navigatorWithUAData = navigator as NavigatorWithUAData;

  return (navigatorWithUAData.userAgentData?.brands || [])
    .map((brandInfo) => brandInfo.brand.toLowerCase())
    .filter(Boolean);
};

export const isGoogleChromeBrowser = (): boolean => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const brands = getNormalizedBrands();

  if (brands.some((brand) => brand.includes("microsoft edge"))) {
    return false;
  }

  if (brands.some((brand) => brand.includes("google chrome"))) {
    return true;
  }

  if (
    /edg\//i.test(userAgent) ||
    /edge\//i.test(userAgent) ||
    /opr\//i.test(userAgent) ||
    /opera\//i.test(userAgent) ||
    /firefox\//i.test(userAgent) ||
    /fxios\//i.test(userAgent) ||
    /samsungbrowser\//i.test(userAgent) ||
    /whale\//i.test(userAgent) ||
    /vivaldi\//i.test(userAgent) ||
    /duckduckgo\//i.test(userAgent) ||
    /yabrowser\//i.test(userAgent)
  ) {
    return false;
  }

  return /crios\//i.test(userAgent) || /chrome\//i.test(userAgent);
};

export const shouldShowChromeRecommendationToast = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  if (isWebView() || isAppleVisionPro()) {
    return false;
  }

  return !isGoogleChromeBrowser();
};

const CHROME_RECOMMENDATION_KEY = "viewrChromeRecommendationShown";
let chromeRecommendationClaimed = false;

export const claimChromeRecommendationToast = (): boolean => {
  try {
    if (sessionStorage.getItem(CHROME_RECOMMENDATION_KEY)) return false;
    sessionStorage.setItem(CHROME_RECOMMENDATION_KEY, "true");
  } catch {
    if (chromeRecommendationClaimed) return false;
  }
  chromeRecommendationClaimed = true;
  return true;
};

export const resetChromeRecommendationToast = (): void => {
  chromeRecommendationClaimed = false;
  try { sessionStorage.removeItem(CHROME_RECOMMENDATION_KEY); } catch { /* Storage may be unavailable. */ }
};
